import {
  Configuration,
  FieldAccessLevel,
  FieldAccessLevelValue,
  FieldInputType,
  FieldInputTypeValue,
  FieldType,
  FieldTypeValue,
  RawConfiguration
} from './configuration-service-types'

export const findFieldInputTypeByName = (name: string): FieldInputTypeValue | undefined =>
  Object.values(FieldInputType).find(v => v.name === name)

export const findFieldAccessLevelByName = (name: string): FieldAccessLevelValue | undefined =>
  Object.values(FieldAccessLevel).find(v => v.name === name)

export const findFieldTypeByName = (name: string): FieldTypeValue | undefined =>
  Object.values(FieldType).find(v => v.name === name)

export const parseConfiguration = (raw: RawConfiguration): Configuration.Model => ({
  ...raw,
  type: findFieldTypeByName(raw.type),
  accessLevel: findFieldAccessLevelByName(raw.accessLevel),
  fieldConfig: {
    ...raw.fieldConfig,
    inputType: findFieldInputTypeByName(raw.fieldConfig.inputType)
  }
})
